import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL } from '../Dashboard/api/Api';
import Axios from '../../axios/Axios';

const AwsSettings = () => {
    const { id, userType } = useParams();

    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const token = lStorage?.token;
    const loginUserType = lStorage?.user?.isAdmin;
    const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children


    const [email, setEmail] = useState("");
    const [awsAccessKeyId, setAwsAccessKeyId] = useState("");
    const [awsSecretAccessKey, setAwsSecretAccessKey] = useState("");
    const [awsRegion, setAwsRegion] = useState("");
    const [awsRecordExists, setAwsRecordExists] = useState(false);

    const [remark, setRemark] = useState("");

    const [error, setError] = useState({
        errorStatus: false,
        errorMessage: "",
        bgColor: ""
    });

    useEffect(() => {
        getUserDetails();
        getAwsSettings();
    }, []);

    const getUserDetails = async () => {
        try {
            const res = await Axios.post(
                `${HOST_URL}/admin_user_list.php`,
                {
                    user_id: Number(userId),
                    method: "retrieve",
                    type: "userdetails",
                    ret_user_id: Number(id),
                    token,
                },
                { headers: { "Content-Type": "application/json" } }
            );

            if (res.data?.success && res.data?.data?.length > 0) {
                setEmail(res.data.data[0].email || "");
            } else {
                console.error(res.data?.message);
            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    };


    const saveAwsSettings = async () => {
    setError({
        errorStatus: false,
        errorMessage: "",
        bgColor: ""
    });

    if (!awsAccessKeyId || !awsSecretAccessKey || !awsRegion) {
        setError({
            errorStatus: true,
            errorMessage: "All AWS fields are required",
            bgColor: "alert alert-danger alert-dismissible"
        });
        return;
    }

    const apiMethod = awsRecordExists
        ? "update_aws_setting"
        : "insert_aws_setting";

    try {
        const res = await Axios.post(
            `${HOST_URL}/admin_user_list.php`,
            {
                user_id: Number(userId),
                token,
                ret_user_id: Number(id),
                method: apiMethod,
                type: loginUserType,
                access_key: awsAccessKeyId,
                secret_key: awsSecretAccessKey,
                aws_region: awsRegion,
                remark,
            },
            { headers: { "Content-Type": "application/json" } }
        );

        if (res.data?.success) {
            setError({
                errorStatus: true,
                errorMessage: res.data.message,
                bgColor: "alert alert-success alert-dismissible"
            });
             getAwsSettings();
          
        } else {
            setError({
                errorStatus: true,
                errorMessage: res.data?.message,
                bgColor: "alert alert-danger alert-dismissible"
            });
        }
    } catch {
        setError({
            errorStatus: true,
            errorMessage: "Something went wrong while saving AWS settings",
            bgColor: "alert alert-danger alert-dismissible"
        });
    }
};

  const getAwsSettings = async () => {

    try {
        const res = await Axios.post(
            `${HOST_URL}/admin_user_list.php`,
            {
                user_id: Number(userId),
                token,
                ret_user_id: Number(id),
                type: loginUserType,
                method: "retrieve_aws_setting",
            },
            { headers: { "Content-Type": "application/json" } }
        );

        if (
            res.data?.success === true &&
            Array.isArray(res.data.data) &&
            res.data.data.length > 0
        ) {
            const data = res.data.data[0];

            setAwsAccessKeyId(data.access_key_id || "");
            setAwsSecretAccessKey(data.secret_access_key || "");
            setAwsRegion(data.region || "");
            setRemark(data.remark || "");

            setAwsRecordExists(true); 
        }
    } catch (err) {
        setAwsRecordExists(false);
    }
};

    return (
        <div className="wrapper">
            <AdminLeftMenu />

            <div className="main">
                <AdminHeader />

                <main className="content">
                    <div className="container-fluid p-0">

                        {/* PAGE HEADER */}
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    User Details{" "}
                                    <strong className="text-info">
                                        {email}
                                    </strong>
                                </h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="card">

                                {/* BREADCRUMB */}
                                <div className="card-header">
                                    <h5 className="card-title mb-0">
                                        <div >
                                            <nav className="text-center" aria-label="breadcrumb">
                                                <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">

                                                    <Link to={`/admin/user-details/${id}/${userType}`}>
                                                        <li className="breadcrumb-item">User Details</li>
                                                    </Link>

                                                    {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.transactiondetails)) && 
                                                    <Link to={`/admin/user-transaction-details/${id}/${userType}`}>
                                                        <li className="breadcrumb-item">Transaction Details</li>
                                                    </Link>}

                                                    {(loginUserType==="admin" || loginUserType === "reseller" || loginUserType === "emp" || (loginUserType==="subadmin" && permissionsubadmin.transactiondetails)) && 
                                                    <Link to={`/admin/user-price-details/${id}/${userType}?channel=whatsapp`}>
                                                        <li className="breadcrumb-item">Add Price</li>
                                                    </Link>}

                                                    {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.awssettings)) && (
                                                        <Link to={`/admin/aws-settings/${id}/${userType}?channel=whatsapp`}>
                                                            <li className="breadcrumb-item active">AWS Settings</li>
                                                        </Link>
                                                    )}

                                                    {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.billingmode)) &&  (
                                                        <Link to={`/admin/user-billing-mode/${id}/${userType}`}>
                                                            <li className="breadcrumb-item">Billing Mode</li>
                                                        </Link>
                                                    )}

                                                    {(loginUserType==="admin" || loginUserType === "reseller" || loginUserType === "emp" || (loginUserType==="subadmin" && permissionsubadmin.transactiondetails)) && 
                                                    <Link to={`/admin/user-add-price/${id}/${userType}`}>
                                                        <li className="breadcrumb-item">Add Credit</li>
                                                    </Link>}

                                                    {loginUserType === "reseller" ? null : (
                                                        <>
                                                                    {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.entitybypass)) &&
                                                                    <Link to={`/admin/user-entity-pass/${id}/${userType}`}>
                                                                        <li className="breadcrumb-item">Entity By Pass</li>
                                                                    </Link>}

                                                                    {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.changecurrency)) &&<Link to={`/admin/change-currency/${id}/${userType}`}>
                                                                        <li className="breadcrumb-item">Change Currency</li>
                                                                    </Link>}

                                                                    {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.bulksmsroutesetting)) &&
                                                                    <Link to={`/admin/bulk-sms-route/${id}/${userType}`}>
                                                                        <li className="breadcrumb-item">
                                                                            Bulk Sms Route Setting
                                                                        </li>
                                                                    </Link>}


                                                            {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.autoshorturl)) && (
                                                                <Link to={`/admin/api-auto-short-url/${id}/${userType}`}>
                                                                    <li className="breadcrumb-item">Auto Short URL</li>
                                                                </Link>
                                                            )}

                                                            {(loginUserType === "admin" || loginUserType === "emp" || (loginUserType==="subadmin" && permissionsubadmin.extrasettings)) && (
                                                                <Link to={`/admin/extra-settings/${id}/${userType}`}>
                                                                    <li className="breadcrumb-item">Extra Settings</li>
                                                                </Link>
                                                            )}

                                                            {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.mmlite)) &&(
                                                                <Link to={`/admin/mmlite/${id}/${userType}`}>
                                                                    <li className="breadcrumb-item">MMLite</li>
                                                                </Link>
                                                            )}

                                                            {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.ai_bot)) &&(
                                                                <Link to={`/admin/ai-bot/${id}/${userType}`}>
                                                                    <li className="breadcrumb-item">AI Bot</li>
                                                                </Link>
                                                            )}

                                                            {(loginUserType==="admin" || (loginUserType==="subadmin" && permissionsubadmin.edituserplan)) &&(
                                                                <Link to={`/admin/edit-user-plan/${id}/${userType}`}>
                                                                    <li className="breadcrumb-item">Edit User Plan</li>
                                                                </Link>
                                                            )}
                                                            

                                                            {/* {loginUserType === "admin" && (
                                                                <Link to={`/admin/ivr-setting/${id}/${userType}`}>
                                                                    <li className="breadcrumb-item">
                                                                        IVR Setting
                                                                    </li>
                                                                </Link>
                                                            )} */}
                                                        </>
                                                    )}

                                                </ol>
                                            </nav>
                                        </div>
                                    </h5>
                                </div>

                                {/* FORM */}
                                <div className="card-body">
                                    {error.errorStatus && (
                                        <div className={error.bgColor} role="alert">
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">×</span>
                                            </button>
                                            <div>{error.errorMessage}</div>
                                        </div>
                                    )}
                                    <form className="form-row">
                                        <div className="row">
                                            <div className="mb-3 col-md-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Access Key ID"
                                                    value={awsAccessKeyId}
                                                    onChange={(e) => setAwsAccessKeyId(e.target.value)}
                                                />
                                            </div>

                                            <div className="mb-3 col-md-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Secret Access Key"
                                                    value={awsSecretAccessKey}
                                                    onChange={(e) => setAwsSecretAccessKey(e.target.value)}
                                                />
                                            </div>

                                            <div className="mb-3 drop-down-icons col-md-4">
                                                <select
                                                    className="form-control"
                                                    value={awsRegion}
                                                    onChange={(e) => setAwsRegion(e.target.value)}
                                                >
                                                    <option value=""> Select Region </option>
                                                    <option value="us-east-1">us-east-1</option>
                                                    <option value="us-east-2">us-east-2</option>
                                                    <option value="us-west-1">us-west-1</option>
                                                    <option value="us-west-2">us-west-2</option>
                                                    <option value="af-south-1">af-south-1</option>
                                                    <option value="ap-east-1">ap-east-1</option>
                                                    <option value="ap-south-1">ap-south-1</option>
                                                    <option value="ap-northeast-3">ap-northeast-3</option>
                                                    <option value="ap-northeast-2">ap-northeast-2</option>
                                                    <option value="ap-southeast-1">ap-southeast-1</option>
                                                    <option value="ap-southeast-2">ap-southeast-2</option>
                                                    <option value="ap-northeast-1">ap-northeast-1</option>
                                                    <option value="ca-central-1">ca-central-1</option>
                                                    <option value="eu-central-1">eu-central-1</option>
                                                    <option value="eu-west-1">eu-west-1</option>
                                                    <option value="eu-west-2">eu-west-2</option>
                                                    <option value="eu-south-1">eu-south-1</option>
                                                    <option value="eu-west-3">eu-west-3</option>
                                                    <option value="eu-north-1">eu-north-1</option>
                                                    <option value="me-south-1">me-south-1</option>
                                                    <option value="sa-east-1">sa-east-1</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="mb-3 col-md-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Remark"
                                                    value={remark}
                                                    onChange={(e) => setRemark(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 mt-2 text-right">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-primary"
                                                onClick={saveAwsSettings}
                                            >
                                                {awsRecordExists ? "Update AWS Settings" : "Save AWS Settings"}
                                            </button>

                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>

                    </div>
                </main>

                <AdminFooter />
            </div>
        </div>
    );
};

export default AwsSettings;
